export const getFilters = (index) => (data) =>
  [
    ...new Map(
      data
        .reduce(
          (acc, item) => [...acc, ...item._embedded["wp:term"][index]],
          []
        )
        .map((item) => [item["id"], item])
    ).values(),
  ];
